// 涉及到账户的相关信息
const account = {
  namespaced: true,
  state: {
    // 接口数据
    accountData: {
      typeA: [],
      typeB: [],
      typeC: {},
      typeD: {}
    },
    // 经过处理的可使用下拉账户列表
    accountMap: {
      typeAMap: {},
      typeCMap: {},
      typeDMap: {}
    },
    // 获取账户的旧接口的响应
    accountResponse: {},
    accountInfo: {
      // 是否有D类账户
      hasMsbdAccount: false
    },
    /*
      临时白名单，对白名单的账户的文件做宽松处理。收款申报不做，白名单处理。汇款申报（跨行汇款、汇款申报查询），做白名单处理 '隐藏资金证明材料'——无需上传文件。
    */
    allowList: ['CB10000176', 'CB10006802']
  },
  mutations: {
    SET_ACCOUNT_DATA (state, data) {
      state.accountData = Object.assign({}, state.accountData, data)
    },
    SET_ACCOUNT_MAP (state, map) {
      state.accountMap = Object.assign({}, state.accountMap, map)
    },
    SET_ACCOUNT_RESPONSE (state, response) {
      state.accountResponse = response
    },
    SET_ACCOUNT_INFO (state, info) {
      state.accountInfo = Object.assign({}, state.accountInfo, info)
    }
  },
  actions: {
  }
}

export default account
